export default Object.freeze({
  ascending: 'asc',
  descending: 'desc',
})
